<template>
  <div v-if="loading">
    <v-skeleton-loader
      class="mb-6"
      type="image"
    />
    <v-container>
      <v-row
        v-for="i in 10"
        :key="i"
      >
        <v-col cols="2">
          <v-skeleton-loader
            type="image"
          />
        </v-col>
        <v-col cols="10">
          <v-skeleton-loader
            class="mb-4"
            type="heading"
          />
          <v-skeleton-loader
            type="paragraph"
            class="mb-4"
          />
          <v-skeleton-loader
            type="text"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
  <div v-else>
    <v-img
      :src="require('@/assets/img-banner-news.jpg')"
      :contain="$store.state.mobile ? false : true"
      class="mx-auto"
      height="260"
    />
    <v-container class="py-4 mb-8">
      <div class="text-h2 my-3 font-medium line-after mb-6">
        <template v-if="$store.getters.languageGetter === '1'">
          أخبار
        </template>
        <template v-else>
          News
        </template>
      </div>
      <v-row
        v-for="item in newsList.data.items"
        :key="item.id"
      >
        <v-col cols="2">
          <router-link :to="{name: 'NewsDetail', params: {id: item.id}}">
            <v-img
              :src="item.image"
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  />
                </v-row>
              </template>
            </v-img>
          </router-link>
        </v-col>
        <v-col cols="10">
          <div class="mb-2 text-h4 black--text">
            <router-link :to="{name: 'NewsDetail', params: {id: item.id}}">
              {{ $store.getters.languageGetter === '1' ? item.dnames : item.dnamesEn }}
            </router-link>
          </div>
          <div class="mb-4 grey--text text--darken-1">
            {{ $store.getters.languageGetter === '1' ? item.summary : item.summaryEn }}
          </div>
          <div class="grey--text">
            {{ item.createTime.substr(0,10) }}
          </div>
        </v-col>
        <v-col cols="12">
          <v-divider />
        </v-col>
      </v-row>
      <div class="text-center mt-4">
        <v-pagination
          v-if="length"
          v-model="page"
          page-aria-label="Page"
          previous-aria-label="PrevPage"
          next-aria-label="NextPage"
          wrapper-aria-label="Pagination"
          current-page-aria-label="CurrentPage"
          :length="length"
          :total-visible="7"
          @input="changePagination"
        />
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'NewsList',
  data() {
    return {
      page: 1,
      loading: false,
    };
  },
  computed: {
    ...mapState(['newsList']),
    length() {
      return Math.ceil((this.newsList.data.totalItem ? +this.newsList.data.totalItem : 0) / 20);
    },
  },
  created() {
    this.loadPageData();
    this.getAdListAsync();
  },
  methods: {
    ...mapActions(['getAdListAsync']),
    ...mapActions(['getNewsListAsync']),
    loadPageData() {
      this.loading = true;
      this.getNewsListAsync({ p: this.page, pageSize: 10 }).then(() => {
        this.page = +this.newsList.data.p;
      }).finally(() => {
        this.loading = false;
      });
    },
    changePagination() {
      this.loadPageData();
    },
  },
};
</script>
